import type { HTMLProps } from "react";

export function HTML({
  html,
  ...props
}: { html: string } & HTMLProps<HTMLDivElement>) {
  return <div dangerouslySetInnerHTML={{ __html: html }} {...props} />;
}
